import React from 'react';
import styled from 'styled-components';
import { observer, useLocalObservable } from 'mobx-react-lite';
import { useStore } from '../store';
import { Button } from './styled';

const MidiSection = styled.section`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 400px;
`;

const Row = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 1rem;
`;

const Container = styled.div`
  padding: 2.8rem;
  position: relative;
  z-index: 100;
`

export const MidiComponent = observer(() => {
  const store = useStore();
  const midi = store.midi;

  const state = useLocalObservable(() => ({
    selectedInputId: '',
    selectedOutputId: '',

    get inputDevices() {
      return midi.availableMIDIInputs.filter(d => d.id !== this.selectedOutputId);
    },

    get outputDevices() {
      return midi.availableMIDIOutputs.filter(d => d.id !== this.selectedInputId);
    },

    handleInputChange(e) {
      this.selectedInputId = e.target.value;
      midi.selectMIDIInput(this.selectedInputId);
    },

    handleOutputChange(e) {
      this.selectedOutputId = e.target.value;
      midi.selectMIDIOutput(this.selectedOutputId);
    },

    startBroadcasting() {
      midi.startBroadcasting();
    },

    get canBroadcast() {
      return midi.selectedMIDIInput !== null;
    },
  }));

  return (
    <Container>
      <h2>MIDI Settings</h2>
      <MidiSection>
        <Row>
          <label htmlFor="midi-input">Input</label>
          <select id="midi-input" onChange={state.handleInputChange} value={state.selectedInputId}>
            <option value="">-- Select MIDI Input --</option>
            {state.inputDevices.map((device) => (
              <option key={device.id} value={device.id}>
                {device.name}
              </option>
            ))}
          </select>
        </Row>

        <Row>
          <label htmlFor="midi-output">Output</label>
          <select id="midi-output" onChange={state.handleOutputChange} value={state.selectedOutputId}>
            <option value="">-- Select MIDI Output --</option>
            {state.outputDevices.map((device) => (
              <option key={device.id} value={device.id}>
                {device.name}
              </option>
            ))}
          </select>
        </Row>

        <Row>
          <label htmlFor="midi-input-channel">Input Channel</label>
          <select id="midi-input-channel" value={midi.selectedInputChannel} onChange={(e) => midi.setInputChannel(parseInt(e.target.value))}>
            {[...Array(16)].map((_, i) => (
              <option key={i} value={i}>Channel {i + 1}</option>
            ))}
          </select>
        </Row>

        <Row>
          <label htmlFor="midi-output-channel">Output Channel</label>
          <select id="midi-output-channel" value={midi.selectedOutputChannel} onChange={(e) => midi.setOutputChannel(parseInt(e.target.value))}>
            {[...Array(16)].map((_, i) => (
              <option key={i} value={i}>Channel {i + 1}</option>
            ))}
          </select>
        </Row>

        <Button disabled={!state.canBroadcast} onClick={state.startBroadcasting}>
          {midi.isBroadcasting ? 'Sending Events...' : 'Start Broadcasting Events'}
        </Button>
      </MidiSection>

      <canvas id="visual-canvas" width={600} height={400}></canvas>
    </Container>
  );
});
